import script from "./CoinItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CoinItem.vue?vue&type=script&setup=true&lang=js"

import "./CoinItem.vue?vue&type=style&index=0&id=6b060115&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b060115"]])

export default __exports__